// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1TCFe","notes":"Notes_notes__14PFe","note":"Notes_note__24rJ7","markdown":"Notes_markdown__1rm8o"};